/* eslint-disable react-hooks/exhaustive-deps */
import { Form } from 'antd'
import React, { useEffect } from 'react'
import { Message } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { showNotification } from 'src/core/helpers'
import { CustomTextArea, CustomTitle } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { resetSendMessage, sendMessage, sendMessageSelector } from 'src/features'
import MessagereplyFormButtonsContent from './MessagereplyFormButtonsContent/MessagereplyFormButtonsContent'

interface MessageReplyFormProps {
  handleCancel: Function
  message: Message
}

const MessageReplyForm: React.FC<MessageReplyFormProps> = ({ handleCancel, message }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispach = useAppDispatch()
  const { loading, success, error } = useAppSelector(sendMessageSelector)

  const onFinish = ({ replyText }: { replyText: string }) => {
    dispach(sendMessage({
      content: replyText,
      date: new Date(),
      read: true,
      receiver: message.sender,
      sender: 901, // Unknown
      subject: getReplySubject(),
      uuid_message: '1'
    }))
  }

  const getReplySubject = () => {
    const subject = message?.subject
    if (subject?.startsWith('RE:')) return subject
    return `RE: ${subject}`
  }

  const handleReset = ({ closeModal = false }) => {
    form.resetFields()
    handleCancel({ closeModal })
  }

  useEffect(() => {
    if (success) {
      showNotification('success', t('Messages.MessageSendedSuccess'))
      dispach(resetSendMessage())
      handleReset({ closeModal: true })
    }
  }, [success])

  useEffect(() => {
    if (error) {
      showNotification('error', t('Messages.MessageError'))
      dispach(resetSendMessage())
      handleReset({ closeModal: true })
    }
  }, [error])

  return (
    <>
      <Form
        name='basic'
        onFinish={onFinish}
        autoComplete='off'
        form={form}
      >
        <CustomTitle label={t('Messages.ReplyLabel')} />
        <CustomTextArea
          name='replyText'
          placeholder={t('Messages.ReplyPlaceHolder')}
          rows={5}
          required
        />

        <MessagereplyFormButtonsContent
          handleCancel={handleReset}
          loading={loading}
        />
      </Form>
    </>
  )
}

export default MessageReplyForm
